export enum PaymentType {
    cbCharge = 1,
    Visa = 2,
    Mastercard = 3,
    AmericanExpress = 4,
    Discover = 5,
    EFS = 6,
    ComData = 7
}
